import type { ListPublicDistrictApplicationsQuery, ListPublicDistrictApplicationsResponse } from "@/schemas/pgc-api";

import { useApiClients } from "../useApiClients.ts";

export function useDistrictTokenApplicationsRepository() {
    const apiClients = useApiClients();

    /**
     * Retrieve applications for a specific district, filtered by optional query parameters
     */
    async function getDistrictApplicationsByDistrictToken(
        districtToken: string, queryParameters?: Readonly<ListPublicDistrictApplicationsQuery>) {
        return apiClients.pgcAuthlessApiClient.value<ListPublicDistrictApplicationsResponse>(`/api/v1/districts/${districtToken}/applications`, {
            query: queryParameters,
        });
    }
    
    return { getDistrictApplicationsByDistrictToken };
}